export default "__VITE_ASSET__daf14f36__"